import { BodyM } from '@casavo/base-ui'
import React from 'react'

import { FilterZone } from '@/types/filter'

import { geoInfo } from '../../styles.css'

type Props = {
  activeZones: FilterZone[]
  area: string
}

export const GeoInfo: React.FC<Props> = (props) => {
  return (
    <BodyM strong className={geoInfo}>
      {props.area}
      {props.activeZones.length > 0 && (
        <>
          , &nbsp;
          {props.activeZones.map((zone, index) => (
            <React.Fragment key={zone.slug}>
              {zone.label}
              {index !== props.activeZones.length - 1 && <>, &nbsp;</>}
            </React.Fragment>
          ))}
        </>
      )}
    </BodyM>
  )
}
